/**
 * Custom error class for Deepgram WebSocket connection loss.
 * Used to distinguish connection loss errors from other errors in error handling.
 */
export class DeepgramConnectionLostError extends Error {
  public readonly code: number;
  public readonly reason: string;
  public readonly connectionDurationMs: number | undefined;
  public readonly isExpected: boolean;
  public readonly reasonCategory: string;

  constructor(
    message: string,
    code: number,
    reason: string,
    isExpected: boolean,
    reasonCategory: string,
    connectionDurationMs: number | undefined,
  ) {
    super(message);
    this.name = 'DeepgramConnectionLostError';
    this.code = code;
    this.reason = reason;
    this.isExpected = isExpected;
    this.reasonCategory = reasonCategory;
    this.connectionDurationMs = connectionDurationMs;
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DeepgramConnectionLostError);
    }
  }
}
